// @noflow
import { filter, flowRight, identity, join, map, toLower } from 'lodash/fp';

export const buildKey = (...params) => flowRight(join('-'), map(toLower), filter(identity))([...params]);



// WEBPACK FOOTER //
// ./src/core/utils/app-settings.js